export default originalValue => Math.trunc(originalValue);
